/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react' 
import { IFestival, IProject } from '../../../data/interfaces'
import { IFestDataStor, IFestProjectsProps, useFestDataStore, useFestProjects } from '../../../data/store'
import { __ } from '@libs/utilities'
import FieldInput, { SCALAR_TYPES } from '@libs/scalars'
import { IMarker, Map } from '@libs/yandexMap'
import { jsonToData } from '@/modules/pe-fest-module/widgets/project-extended-fields/ExtendFieldSingleForm'
import { Collapsed } from '../ProjectData'
import { useUserOwner } from '@/modules/pe-fest-module/hooks/project'
import { isRole } from '@/settings/zustand/user'
import { getModeratorRoles } from '@/modules/pe-fest-module/data/utils/getModeratorRoles'
import { ConfirmButton } from 'src/libs/useful'
import { Button, ButtonVariant, Intent } from '@blueprintjs/core'
import { useParams } from 'react-router'
import actions from 'src/modules/pe-basic-module/data/actions'
import { UPDATE_SINGLE_ACTION } from 'src/modules/pe-fest-module/data/actionTypes'
import { useSyncState } from 'src/modules/pe-basic-module/hooks/useSyncState'


export interface IExtendsFormsProps {
    item : IProject 
    hidden: string
    isCollapseOpen:boolean
    vertical?:boolean
    className?: string
    titleClassName?: string
}
const ExtendedForms = (props: IExtendsFormsProps) : JSX.Element[] | undefined => {
    const festival : IFestival = useFestDataStore((state:IFestDataStor) => state.festival ) 
    const { extendedFields } = festival
    const is_owner:boolean = useUserOwner( props.item ) 
    
    //console.log(props.item.form_fields)
    //console.log(extendedFields)
    //console.log(is_owner)
    
    return extendedFields?.map( (field: any, i:number ) => {
        const usl :boolean = field[ props.hidden ] || 
            ( 
                !!extendedFields[i].hide_for_alien &&           // поле скрыто для чужаков
                !( is_owner || isRole( getModeratorRoles() ) )  // Вы не владелец и не админ
            )  
        return usl
            ?
            <Fragment key={ field.id } />
            :
            <SingleExtendedForm
                field={ field }
                key={ field.id }
                data={ props.item.form_fields[i] ? props.item.form_fields[i] : undefined }
                i={i} 
                isCollapseOpen={ props.isCollapseOpen }
                vertical={ props.vertical }
                className={props.className}
                titleClassName={props.titleClassName}
                is_owner={is_owner}
            /> 
    }) 
} 

export default ExtendedForms

export const SingleExtendedForm = (props:any): JSX.Element => {    
    const festival : IFestival = useFestDataStore((state:IFestDataStor) => state.festival )  
    const extendedFields = festival.extendedFields || []  
    return <div>  
        <Collapsed
            vertical={ props.vertical }
            isOpen={props.isCollapseOpen  || extendedFields[ props.i ].highlighted}
            title={extendedFields[ props.i ].name}
            className={` ${props.titleClassName} `}
            description={ 
                    <>{
                        //props.data 
                        Array(extendedFields[ props.i ].count).fill(1)
                            //.filter( (d:any) =>  typeof d !== "undefined" )
                            .map( ( d: any, i: number ) => <SingleField
                                key={ props.i }
                                i={ props.i }
                                ii={i}
                                item={ Array.isArray( props.data ) ? props.data[ i ]: undefined }
                                type={extendedFields[ props.i ].type}
                                values={( extendedFields[ props.i ].values || "" ).split("/")}
                                description={extendedFields[ props.i ].description}
                                className={`${props.className} my-0 p-0`}
                                is_owner={props.is_owner}
                            />  )
                    }</> 
            }
        />
    </div>
     
}

const SingleField = (props: any) :JSX.Element => {
    const item      = useSyncState<any>(props.item)
    const isLoading = useSyncState<boolean>(false)
    useEffect(() => {
        item.set( props.item )
    }, [ props.item ])

    const { is_owner, className, i, ii, type, description, values } = props
    const { landId } = useParams()
    const project: IProject = useFestProjects((state: IFestProjectsProps) => state.currentProject)

    const onChange = (value: any, field: string="") => {
        item.set( value )
    }
    const onUpdate = () => {
        const _ii           = Number( i )
        const _i            = Number( ii )
        let _item           = item.get()

        let form_fields     = [ ...project.form_fields || [] ]
        if( !Array.isArray( form_fields[ _ii ] ) ) {
            form_fields[_ii]= []
        }
        //console.log(_item, _i , _ii, "form_fields: ", form_fields, "project.form_fields: ", project.form_fields )
        let fff: any[]      = !Array.isArray( form_fields[ _ii ] ) ? form_fields[ _ii ] : []
        
        //console.log( fff, _i, _item )
        //console.log( "fff[ _i ] = ", fff[ _i ] )
        
        !!_item ? fff.splice( _i, 1, _item ) : fff.splice( _i, 1, null )        
        form_fields.splice( _ii, 1, fff )

        //console.log( form_fields, fff )

        let data: any = {
            data_type : "PEFestProject",
            id: project.id,
            item: { 
                form_fields : form_fields, 
            },
            landId: landId
        }  
        //console.log( data )
        isLoading.set(true)
        actions( UPDATE_SINGLE_ACTION, data )
            .then(r => {
                //console.log(r)
                isLoading.set(false)
            })
    }
    const onClear = () => {
        item.set( "" )
        onUpdate()
    }
    const onCheckboxChange = (value: any) => { 
        if(!is_owner) return       
        //console.log(value)
        item.set(JSON.stringify(value))        
    }
    const onMapChange = (coords: any) => { 
        if(!is_owner) return       
        //console.log(coords)
        item.set(JSON.stringify(coords))        
    }
    const onMapWeel = (coords: any) => {       
        if(!is_owner) return       
        const coordinates =  jsonToData( item.get() )        
        //console.log( coordinates )        
        //console.log( [ coordinates[0], coordinates[1], coords[2] ] )
        item.set( JSON.stringify([coordinates[0], coordinates[1], coords[2]]) )       
    }
    const _item = item.get()
    let form =<></>
    switch(type) {
        case SCALAR_TYPES.GEO:
            form = <Map 
                width="100%"
                height={ 230 }
                coordinates={ jsonToData( _item ) }
                markers={ [ 
                    { coordinates: jsonToData( _item ) } as IMarker
                ] } 
                data-testid="project-data-extended-field"
                onClick={ is_owner ? onMapChange : undefined  }
                onWeel={ is_owner ? onMapWeel : undefined  }
            /> 
            break
        case SCALAR_TYPES.CHECKBOX: 
            form = <FieldInput
                type={  type }
                value={ jsonToData( _item ) }
                values={ values }
                className={`${className} form-control input dark `}
                data-testid="project-data-extended-field"
                commentary={is_owner ? description : undefined}
                editable={ is_owner } 
                notClear
                onChange={ is_owner ? onCheckboxChange : undefined }
            /> 
            break
        case SCALAR_TYPES.STRING:
        default:
            form = <FieldInput
                type={  type }
                value={ _item }
                values={ values }
                className={`${className} form-control input dark `}
                data-testid="project-data-extended-field"
                commentary={ is_owner ? description : undefined }
                editable={ is_owner && !props.item }
                limitSize={ type === SCALAR_TYPES.MEDIA ? 5000000 : 15000 }
                isURLHide
                notClear
                onChange={ is_owner ? onChange : undefined }
            /> 
            break
    }

    return <div className="d-flex align-items start w-100 flex-grow-100 "> 
        <div className='w-100 d-flex flex-grow-100 '>
        { form }
        {
            is_owner 
                ?
                _item !== props.item || !props.item
                    ?
                    <div>
                        <Button 
                            intent={Intent.SUCCESS} 
                            icon="tick" 
                            disabled={ !_item } 
                            variant={ !!_item ? ButtonVariant.SOLID : ButtonVariant.MINIMAL } 
                            onClick={onUpdate}
                            loading={ isLoading.get() }
                        />
                        <div></div>
                    </div>
                    :
                    <div> 
                        <ConfirmButton
                            onConfirm={onClear}
                            popover={ <div className="px-3 py-2">{ __( "Remove" ) }</div> }
                            buttonMinimal
                            buttonIcon="cross"
                            isPopover
                            buttonIntent={ Intent.DANGER }
                        >
                            <div className="p-5 text-center lead">
                                {__("Really remove attachment?")}
                            </div>
                        </ConfirmButton>
                        <div></div>
                    </div>
                :
                <></>
        } 
        </div> 
    </div> 
} 

const UploadEngine = (props: any) : JSX.Element => {
    const {is_owner, item, className, i, ii} = props
    const {landId} = useParams()
    const project: IProject = useFestProjects((state: IFestProjectsProps) => state.currentProject)
    if(!is_owner && !item) {
        return <>
        
        </>
    }

    const onChange = (value: string) => {
        let ff = [...project.form_fields || []]
        if( !Array.isArray(ff[Number(ii)]) ) ff[Number(ii)] = []
        let fff = [...ff[i]]
        fff[ii] = value
        ff[Number(ii)] = fff
        let data: any = {
            data_type : "PEFestProject",
            id: project.id,
            item: { 
                form_fields : ff, 
            },
            landId: landId
        }  
        console.log( data )
        actions( UPDATE_SINGLE_ACTION, data )
            .then(r => console.log(r))
    }

    if(is_owner && !!item) {
        return <div className="d-flex">
            <FieldInput
                type={ SCALAR_TYPES.UPLOAD }
                value={ item }
                // className={`${ className || ""}  w-100 text-dark opacity_75`}
                limitSize={15000}
                notClear
                data-testid="project-data-extended-field"
            />
            <ConfirmButton
                onConfirm={() => onChange("")}
                buttonLabel={__("Remove")}
                buttonMinimal
                buttonIcon="cross"
                buttonIntent={ Intent.DANGER }
            >
                <div className="p-5 text-center lead">
                    {__("Really remove attachment?")}
                </div>
            </ConfirmButton>
        </div>
    }
    
    return <FieldInput
        type={ SCALAR_TYPES.UPLOAD }
        value={ item }
        limitSize={5000}
        editable={ is_owner}
        onChange={onChange}
        className={`${ className || ""}  w-50 text-dark opacity_75`}
        notClear
        data-testid="project-data-extended-field"
    /> 

}